import { render, staticRenderFns } from "./commonLeveReq.vue?vue&type=template&id=23fbac59&"
import script from "./commonLeveReq.vue?vue&type=script&lang=js&"
export * from "./commonLeveReq.vue?vue&type=script&lang=js&"
import style0 from "./commonLeveReq.vue?vue&type=style&index=0&id=23fbac59&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports